import { Link } from 'react-router-dom';
import { Phone, Mail, Heart, PawPrint, Instagram, Facebook, MapPin } from 'lucide-react';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-rose-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand Section */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 bg-gradient-to-br from-rose-100 to-pink-50 rounded-full flex items-center justify-center">
                <PawPrint className="w-5 h-5 text-[#E85D75]" />
              </div>
              <div>
                <h3 className="text-lg font-serif font-bold text-stone-800">KITTENSTATE</h3>
                <p className="text-[9px] uppercase tracking-[0.15em] text-stone-400">Premium Scottish Kittens</p>
              </div>
            </Link>
            <p className="text-sm text-stone-600 leading-relaxed mb-4">
              Healthy, social, and beautiful Scottish Fold and Scottish Straight kittens, 
              raised with love in a home environment.
            </p>
            <div className="flex gap-3">
              <a 
                href="#" 
                className="w-9 h-9 bg-rose-50 rounded-full flex items-center justify-center text-[#E85D75] hover:bg-[#E85D75] hover:text-white transition-all"
              >
                <Instagram className="w-4 h-4" />
              </a>
              <a 
                href="#" 
                className="w-9 h-9 bg-rose-50 rounded-full flex items-center justify-center text-[#E85D75] hover:bg-[#E85D75] hover:text-white transition-all"
              >
                <Facebook className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-stone-800 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              {[
                { name: 'Available Kittens', path: '/kittens' },
                { name: 'About Us', path: '/about' },
                { name: 'Health & Care', path: '/adoption-process' },
                { name: 'Kitten Process', path: '/faq' },
                { name: 'Contact', path: '/contact' },
              ].map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-stone-600 hover:text-[#E85D75] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-stone-800 mb-4">Support</h4>
            <ul className="space-y-2.5">
              {[
                { name: 'FAQ', path: '/faq' },
                { name: 'Shipping & Delivery', path: '/adoption-process' },
                { name: 'Kitten Care', path: '/adoption-process' },
                { name: 'Reviews', path: '/contact' },
              ].map((link) => (
                <li key={link.name}>
                  <Link
                    to={link.path}
                    className="text-sm text-stone-600 hover:text-[#E85D75] transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-stone-800 mb-4">Contact Us</h4>
            <div className="space-y-3">
              <a
                href="tel:929-333-1936"
                className="flex items-center text-sm text-stone-600 hover:text-[#E85D75] transition-colors"
              >
                <Phone className="w-4 h-4 mr-2 text-[#E85D75]" />
                929-333-1936
              </a>
              <a
                href="mailto:sales@kittenstate.com"
                className="flex items-center text-sm text-stone-600 hover:text-[#E85D75] transition-colors"
              >
                <Mail className="w-4 h-4 mr-2 text-[#E85D75]" />
                sales@kittenstate.com
              </a>
              <div className="flex items-start text-sm text-stone-600">
                <MapPin className="w-4 h-4 mr-2 mt-0.5 text-[#E85D75] flex-shrink-0" />
                <div>
                  <p>Covington Township, PA 18424</p>
                  <p className="text-xs text-stone-500 mt-0.5">Visits by appointment only</p>
                </div>
              </div>
            </div>
            <div className="mt-6 p-4 bg-rose-50/50 rounded-xl">
              <p className="text-xs text-stone-600 leading-relaxed">
                <strong className="text-stone-800">Hours:</strong><br />
                Mon - Sat: 9am - 7pm<br />
                Sun: By appointment
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-rose-100 mt-12 pt-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-stone-500 text-sm flex items-center">
              © {currentYear} KittenState. Made with <Heart className="w-3.5 h-3.5 mx-1 text-[#E85D75] fill-[#E85D75]" /> All rights reserved.
            </p>
            <div className="flex gap-6 text-xs text-stone-500">
              <Link to="/faq" className="hover:text-[#E85D75] transition-colors">Privacy Policy</Link>
              <Link to="/faq" className="hover:text-[#E85D75] transition-colors">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
